/*eslint-disable*/ export const messages = {
    Apply: "Aplicar",
    Clear: "Clear",
    "Date picker open, choose a date": "Seletor de data aberto, escolha uma data",
    "Date range picker open, select a date range":
        "Seletor de intervalo de datas aberto, selecione um intervalo de datas",
    "End Date": "Data de término",
    "Please enter a date ({format})": ["Insira uma data (", ["format"], ")"],
    "Please select a date after {minDate}": ["Selecione uma data posterior a ", ["minDate"]],
    "Please select a date before {maxDate}": ["Selecione uma data anterior a ", ["maxDate"]],
    "Show next month": "Mostrar próximo mês",
    "Show previous month": "Mostrar mês anterior",
    "Start Date": "Data de início",
    "The selected date is disabled": "A data selecionada está desativada",
    "The selected date is unavailable. Please select another.":
        "A data selecionada não está disponível. Selecione outra.",
    Today: "Today",
    "Today, {dateStr}": ["Hoje, ", ["dateStr"]],
    "date picker": "seletor de datas",
    "start date selected": "data de início selecionada",
    to: "to",
    "{dateStr}, select end date": [["dateStr"], ", selecione a data de término"],
    "{dateStr}, select start date": [["dateStr"], ", selecione a data de início"],
    "{startDate} to {endDate}, choose apply to confirm, or cancel": [
        ["startDate"],
        " a ",
        ["endDate"],
        ", escolha aplicar para confirmar ou cancelar",
    ],
};
